import React from 'react';
import './me.css';
// import hku from '../images/hku.png';
function CV() {
  return (
    <>
     <h2 className='heading_2'>
        About Me
</h2>
    <div class="graphic-container">
 
  <div class="center-circles-container">
    
    <div class="single">
      <div class="circle one">
        <div class="dot"></div>
        <div class="icon">
          <i class="fa fa-graduation-cap"></i>
        </div>
        <div class="content-container">
          <div class="line"></div>
          <h2>Education</h2>
          <div class="content">
            <h3> HKU  </h3>

            <p>I am a full-time UG student enrolled in the <em>BEng (CompSc and Finance).</em><br/>Sep 2019 – Expected May 2023</p>
          </div>
        </div>
      </div>
    </div>
    <div class="double">
      <div class="circle two">
        <div class="icon">
          <i class="far fa-book"></i>
        </div>
        <div class="content-container">
          <div class="line"></div>
          <h2>Scholarships</h2>
          <div class="content">
            <h3>HKU Foundation Scholarship : 2019-23</h3>
            <p>Full tuition fee for the entirety of undergraduate studies. Renewed for 2020,2021</p>
          
          </div>
        </div>
        </div>
      <div class="circle three">
        <div class="icon">
          <i class="far fa-cubes"></i>
        </div>
        <div class="content-container">
          <div class="line"></div>
          <h2> Competitions</h2>
          <div class="content">
            <p>InnoTech AI Solutions Competition <em>Second Prize</em></p>
            <p>The 7th HK University Student Innovation and Entrepreneurship Competition<em> <br/>Third Prize</em></p>
            <p>The 7th China International College Students’ “Internet+” Innovation & Entrepreneurship Competition  <em><br/>Second Prize</em></p>
            <p>“金湾杯”第八届“创青春”粤港澳大湾青年创新创业大赛 <em><br/> Third Prize</em></p>

          </div>
        </div>
        </div>
    </div>
    <div class="double">
      <div class="circle four">
        <div class="dot"></div>
        <div class="icon">
          <i class="fa fa-lightbulb"></i>
        </div>
        <div class="content-container">
          <div class="line"></div>
          <h2>Interests </h2>
          <div class="content">
            <h3>Debating</h3>
            <p>Avid Debater <br/> <em> HKU English Debate Team 2019-20 <br/> Participated and won prizes in AISCE All India English Debate and Frank Antony All India Debate</em></p>


          </div>
        </div>
        </div>
      <div class="circle five">
        <div class="icon">
          <i class="far fa-film"></i>
        </div>
        <div class="content-container">
          <div class="line"></div>
          <h2> Other Interests</h2>
          <div class="content">
            <p>In my spare time, I enjoy reading fantasy fiction and watching documentaries</p>
          </div>
        </div>
        </div>
    </div>
    <div class="single">
      <div class="circle six">
        <div class="dot"></div>
        <div class="icon">
          <i class="fa fa-music"></i>
        </div>
        <div class="content-container">
          <div class="line"></div>
          <h2>Interests</h2>
          <div class="content">
          <h3>Dancing</h3>

            <p>I am a trained classical dancer in Kathak - an Indian classical dance form.</p>
          </div>
        </div>
        </div>
    </div>
    
  </div>
  
</div>
</>
  );
}

export default CV;
